import * as ACTION from '@Bootstraps/bootstrapActions';
import { useDispatch, useSelector } from 'react-redux';
import { useMemo } from 'react';
import Swal from 'sweetalert2';
import JWTDecode from 'jwt-decode';
import { useEffect } from 'react';

export default function Component() {
  const dispatch = useDispatch();
  const { accessToken, removeAccountResponse, removeAccountError } = useSelector((state) => state);
  const { user } = useMemo(() => {
    return JWTDecode(accessToken);
  }, [accessToken]);

  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      confirmButton: 'btn btn-primary2 text-dark fw-medium px-3',
      cancelButton: 'btn btn-secondary fw-medium me-4 px-3',
    },
    buttonsStyling: false,
  });

  function Remove(id) {
    swalWithBootstrapButtons
      .fire({
        title: 'Are you sure?',
        background: '#252336',
        color: '#3dcd55',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          dispatch(ACTION.removeAccount({ id }));
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          swalWithBootstrapButtons.fire({
            background: '#252336',
            color: '#3dcd55',
            title: 'Canceled!',
            text: 'Remove account is canceled.',
            icon: 'error',
          });
        }
      });
  };

  useEffect(() => {
    if (removeAccountResponse) {
      Swal.fire({
        background: '#252336',
        color: '#3dcd55',
        title: 'Success!',
        text:
          removeAccountResponse?.data?.message ||
          'Successfully removed account',
        confirmButtonColor: '#3dcd55',
        icon: 'success',
      }).then(() => dispatch(ACTION.setAuth(undefined)));
    } else if (removeAccountError) {
      Swal.fire({
        background: '#252336',
        color: '#3dcd55',
        title: 'Failed Remove!',
        text: removeAccountError.message || 'Failed remove account',
        confirmButtonColor: '#3dcd55',
        icon: 'error',
      });
    }
  }, [removeAccountResponse, removeAccountError]);

  return (
    <>
      <div className="auth d-flex justify-content-center">
        <div
          className="avatar rounded-circle border-primary2"
          style={{ backgroundImage: `url(${user.avatar})` }}
        ></div>
      </div>
      <div className="my-5">
        <div className="row align-items-center m-0">
          <div className="col-md-6 ps-0 pe-0 pe-md-2">
            <input
              type="text"
              className="form-control bg-white text-primary2 border-primary2 fw-medium"
              value={`${user?.name?.firstName} ${user?.name?.lastName}`}
              disabled
            />
          </div>
          <div className="col-md-6 pe-0 ps-0 ps-md-2 mt-3 mt-md-0">
            <input
              type="text"
              className="form-control bg-white text-primary2 border-primary2 fw-medium"
              value={user?.username}
              disabled
            />
          </div>
        </div>
        <input
          type="text"
          className="form-control bg-white text-primary2 border-primary2 fw-medium mt-3 mt-md-4"
          value={user?.email}
          disabled
        />
      </div>
      <div className="row m-0">
        <div className="col-md-6 ps-0 pe-0 pe-md-2">
          <button
            className="btn btn-primary2 w-100 fw-semibold text-white py-2"
            onClick={() => dispatch(ACTION.setAuth(undefined))}
          >
            Logout
          </button>
        </div>
        <div className="col-md-6 pe-0 ps-0 ps-md-2">
          <button
            className="btn bg-white border-danger w-100 fw-semibold text-danger py-2 mt-3 mt-md-0"
            onClick={() => Remove(user?.id)}
          >
            Remove Account
          </button>
        </div>
      </div>
    </>
  );
}